import { FC, useState } from "react";
import { UserDTO } from "../../../domain/models/dto/UserDTO";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import { UserServiceImpl } from "../../../services/UserServiceImpl";
import { useNavigate } from "react-router-dom";
import CustomPopup from "../../../custom-components/CustomPopup";

interface BlockedUserItemProps {
    user: UserDTO;
    onUnblockSuccess?: () => void;
}

const BlockedUserItem: FC<BlockedUserItemProps> = ({ user, onUnblockSuccess }) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleUnblock = async () => {
        const result = await dispatch(UserServiceImpl.unblockUserThunk({ userId: user.id }));
        if (result.meta.requestStatus === "fulfilled") {
            onUnblockSuccess?.();
        }
        setIsVisible(false);
    };

    const handleItemClick = () => {
        navigate(`/profile/${user.id}`);
    };

    return (
        <div
            className="w-full flex items-center justify-between rounded-[10px] bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(255,255,255,0.1)] p-4 cursor-pointer"
            onClick={handleItemClick}
        >
            <div className="flex flex-col">
                <span className="H16B text-textWhite">
                    {user.firstName} {user.lastName}
                </span>
            </div>
            <CustomPopup
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                wrapClassName="dmin2:min-w-[628px] di6:min-w-[428px] ti6:min-w-[428px] ti7:min-w-[340px] tmax4:min-w-[340px]"
                confirmTitle={t("common.yes")}
                confirmHandler={handleUnblock}
                confirmButtonClassName="bg-transparent hover:bg-transparent w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mr-8 dmax2:mr-6 mt-8 dmax2:mt-6"
                cancelTitle={t("common.no")}
                cancelButtonClassName="w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
                buttonElement={
                    <div
                        className="px-2 py-1 text-red-500 rounded hover:bg-[rgba(255,255,255,0.1)] transition duration-300"
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsVisible(true);
                        }}
                    >
                        {t("userProfile.unblock")}
                    </div>
                }
            >
                <p className="H20 dmax2:H16 text-textWhite text-center mt-[10px] dmin2:max-w-[420px] di6:max-w-[340px] ti6:max-w-[340px] ti7:max-w-[280px] tmax4:max-w-[280px] break-words">
                    {t("userProfile.blockedUsers.assuranceUnblock", { userName: `${user.firstName} ${user.lastName}` })}
                </p>
            </CustomPopup>
        </div>
    );
};

export default BlockedUserItem;
